import { Tip } from '../store/tips/tips.interface'
import { get } from './request'
import validateLocales from '../helpers/languageFormatter'

export async function fetchTips({ language }: { language?: string }) {
  const tips = await get<Tip[]>('/tip?lng=' + validateLocales(language))
  return tips
}
